const navigation = document.getElementById('main-header')
const logo = document.getElementById('logo-brand')
const toggle = document.getElementById('mobile-toggle')
const mainNavbar = document.getElementById('main-navbar')
let isOpen = false;

window.addEventListener('scroll', (e) => {
  let scroll = window.scrollY;
  if(scroll > 59) {
    navigation.classList.add('h-16', 'md:h-20', 'md:bg-white', 'bg-opacity-95')
    logo.classList.add('md:h-10', 'h-5')
    navigation.classList.remove('h-20', 'md:h-28')
    logo.classList.remove('md:h-14', 'h-7')
  } else {
    navigation.classList.add('h-20', 'md:h-28')
    logo.classList.add('md:h-14', 'h-7')
    navigation.classList.remove('h-16', 'md:h-20', 'md:bg-white', 'bg-opacity-95')
    logo.classList.remove('md:h-10', 'h-5')
  }
})

if(toggle) {
  toggle.addEventListener('click', () => {

    if(!isOpen) {
      mainNavbar.classList.remove('translate-x-full')
      mainNavbar.classList.add('translate-0')
    } else {
      mainNavbar.classList.remove('translate-0')
      mainNavbar.classList.add('translate-x-full')
    }

    isOpen = !isOpen;
  })
}
